export enum StatusOS{
    AVincular = 0,
    CTeEmitido = 1,
    Pendente = 2,
    Vinculada = 3
}